import axios from 'assets/remote/axios';
import { delay, getCurrentUser, setCurrentUser } from 'helpers/Utils';
import { all, fork, takeLatest, put, call } from 'redux-saga/effects';
import {
  GET_PROFILE,
  SEND_OTP_PROFILE_EMAIL,
  SEND_OTP_PROFILE_MOBILE,
  UPDATE_PROFILE,
  UPDATE_PROFILE_EMAIL_MOBILE,
  updateUser,
} from 'redux/actions';
import {
  profile,
  profileError,
  profileSuccess,
  profileSecondsUpdate,
} from './action';

function* errorHandler(error) {
  if ('response' in error) {
    const keys = Object.keys(error?.response?.data?.errors);
    // eslint-disable-next-line no-restricted-syntax
    for (const item of keys)
      yield put(profileError(error?.response?.data?.errors[item][0]));
  } else {
    yield put(profileError(error.message));
  }
}

function* successHandler(user, message) {
  yield put(profile(user));
  yield put(profileSuccess(message));
  yield put(profileSuccess(''));
}

export function* watchGetProfile() {
  // eslint-disable-next-line no-use-before-define
  yield takeLatest(GET_PROFILE, getProfile);
}

const getProfileAsync = async (id) => {
  const r = await axios.get(`/profile/${id}`);
  return r?.data;
};

function* getProfile({ payload }) {
  const { id } = payload;
  try {
    const result = yield call(getProfileAsync, id);
    console.log({ result });
    yield put(updateUser(result.user));
    yield call(successHandler, result.user, 'اطلاعات با موفقیت دریافت شد');
  } catch (error) {
    yield call(errorHandler, error);
  }
}

export function* watchUpdateProfile() {
  // eslint-disable-next-line no-use-before-define
  yield takeLatest(UPDATE_PROFILE, updateProfile);
}

const updateProfileAsync = async (
  id,
  name,
  nationcode,
  //sheba
) => {
  const r = await axios.post(`profile/${id}`, {
    name,
    nationcode,
    // sheba
  });
  return r.data;
};

function* updateProfile({ payload }) {
  const {
    id,
    name,
    nationcode,
    // sheba
  } = payload;
  try {
    const result = yield call(
      updateProfileAsync,
      id,
      name,
      nationcode,
      //sheba
    );
    yield call(successHandler, result.user, result.message);
  } catch (error) {
    yield call(errorHandler, error);
  }
}

export function* watchUpdateProfileMobileEmail() {
  // eslint-disable-next-line no-use-before-define
  yield takeLatest(UPDATE_PROFILE_EMAIL_MOBILE, updateProfileMobileEmail);
}

const updateProfileMobileEmailAsync = async (id, input, code) => {
  const r = await axios.post(`profile/${id}/change/verify`, { input, code });
  return r.data;
};

function* updateProfileMobileEmail({ payload }) {
  const { id, input, code } = payload;
  try {
    const result = yield call(updateProfileMobileEmailAsync, id, input, code);
    yield call(successHandler, result.user, result.message);
    yield put(profileSecondsUpdate(-1));
  } catch (error) {
    yield call(errorHandler, error);
  }
}

export function* watchSendOtpProfileEmail() {
  // eslint-disable-next-line no-use-before-define
  yield takeLatest(SEND_OTP_PROFILE_EMAIL, sendOtpEmailProfile);
}

const sendOtpEmailProfileAsync = async (id, email) => {
  const r = await axios.post(`profile/${id}/change`, { email });
  return r.data;
};

function* sendOtpEmailProfile({ payload }) {
  try {
    const { id, email } = payload;
    const result = yield call(sendOtpEmailProfileAsync, id, email);
    // yield call(delay, 4000);
    yield put(profileSecondsUpdate(result?.seconds ?? 0));
    if (result.success) {
      yield put(profileSuccess(result.message));
      yield put(profileSuccess(''));
    } else {
      yield put(profileError(result.message));
      yield put(profileError(''));
    }
  } catch (error) {
    // yield call(delay, 4000);
    yield call(errorHandler, error);
  }
}

export function* watchSendOtpProfileMobile() {
  // eslint-disable-next-line no-use-before-define
  yield takeLatest(SEND_OTP_PROFILE_MOBILE, sendOtpMobileProfile);
}

const sendOtpMobileProfileAsync = async (id, mobile) => {
  const r = await axios.post(`profile/${id}/change`, { mobile });
  return r.data;
};

function* sendOtpMobileProfile({ payload }) {
  try {
    const { id, mobile } = payload;
    const response = yield call(sendOtpMobileProfileAsync, id, mobile);
    yield put(profileSecondsUpdate(response?.seconds ?? 0));

    if (response.success) {
      yield put(profileSuccess(response.message));
      // yield put(profileSuccess(''));
    } else {
      yield put(profileError(response.message));
      // yield put(profileError(''));
    }
  } catch (error) {
    yield call(errorHandler, error);
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchGetProfile),
    fork(watchUpdateProfile),
    fork(watchUpdateProfileMobileEmail),
    fork(watchSendOtpProfileEmail),
    fork(watchSendOtpProfileMobile),
  ]);
}
